export default __webpack_public_path__ + "assets/centralafricanrepublic-flag.png";